import { render, staticRenderFns } from "./LegalDocumentsDialog.vue?vue&type=template&id=4c83e3ed&scoped=true"
import script from "./LegalDocumentsDialog.vue?vue&type=script&lang=js"
export * from "./LegalDocumentsDialog.vue?vue&type=script&lang=js"
import style0 from "./LegalDocumentsDialog.vue?vue&type=style&index=0&id=4c83e3ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c83e3ed",
  null
  
)

export default component.exports